<div class="w-full border-4 h-0 border-lrpTicketBlue dark:border-blue-700 rounded border-opacity-60 relative" [class.border-8]="large">
    @if (label) {
    <p class="absolute -top-2 left-6 dark:text-lrpTicketBlack bg-white px-2 font-semibold rounded-3xl" [class.-top-3]="large" [class.text-md]="large" [class.text-xs]="!large">
        {{ label }}    
    </p>
    }
</div>